import en from '../../../messages/en.json';
import ru from '../../../messages/ru.json';

/** Pure resources: importing these must not initialize or change the host's locale. */
export const LOCALE_BUNDLES = { en, ru } as const;
